<div class="connectWallet_bg">
    <main class="container">
        <div class="connectWallet" style="overflow: hidden;">
            <picture class="connectWallet__image">
                <source media="(max-width: 900px)" srcset="/assets/image/connectWallet/item-mobile.png" />
                <img src="/assets/image/connectWallet/item.png" alt="Responsive Image" />
            </picture>

            <div class="connectWallet__content">
                <div class="connectWallet__header">
                    <h2 class="connectWallet__header_title">{{ 'connect_wallet.header.title' | translate }}</h2>
                    <p class="connectWallet__header_description">
                        {{ 'connect_wallet.header.description' | translate }}
                    </p>
                </div>

                <div class="connectWallet__list">
                    <button class="button-secondary connectWallet__list_item" (click)="onConnectCoinbase()">
                        <svg width="31" height="30" viewBox="0 0 31 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_392_10171)">
                                <path
                                    d="M15.5 30C23.7843 30 30.5 23.2843 30.5 15C30.5 6.71573 23.7843 0 15.5 0C7.21573 0 0.5 6.71573 0.5 15C0.5 23.2843 7.21573 30 15.5 30Z"
                                    fill="#0052FF" />
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                    d="M4.95312 15C4.95312 20.8249 9.67511 25.5469 15.5 25.5469C21.3249 25.5469 26.0469 20.8249 26.0469 15C26.0469 9.17511 21.3249 4.45312 15.5 4.45312C9.67511 4.45312 4.95312 9.17511 4.95312 15ZM12.8047 11.6016C12.4164 11.6016 12.1016 11.9164 12.1016 12.3047V17.6953C12.1016 18.0836 12.4164 18.3985 12.8047 18.3985H18.1953C18.5836 18.3985 18.8985 18.0836 18.8985 17.6953V12.3047C18.8985 11.9164 18.5836 11.6016 18.1953 11.6016H12.8047Z"
                                    fill="white" />
                            </g>
                            <defs>
                                <clipPath id="clip0_392_10171">
                                    <rect width="30" height="30" fill="white" transform="translate(0.5)" />
                                </clipPath>
                            </defs>
                        </svg>
                        {{ 'connect_wallet.wallet_list.coinbase' | translate }}
                    </button>
                    <button class="button-secondary connectWallet__list_item" (click)="onConnectMetaMask()">
                        <img src="/assets/image/connectWallet/meta-mask.png" alt="Meta Mask Icon" />
                        {{ 'connect_wallet.wallet_list.metamask' | translate }}
                    </button>
                    <button class="button-secondary connectWallet__list_item" (click)="onConnectWalletConnect()">
                        <svg width="31" height="30" viewBox="0 0 31 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                d="M15.5 0C23.7852 0 30.5 6.71484 30.5 15C30.5 23.2852 23.7852 30 15.5 30C7.21484 30 0.5 23.2852 0.5 15C0.5 6.71484 7.21484 0 15.5 0Z"
                                fill="url(#paint0_radial_392_10177)" />
                            <path
                                d="M10.0342 11.584C13.0518 8.63672 17.9502 8.63672 20.9678 11.584L21.3311 11.9414C21.4834 12.0879 21.4834 12.3281 21.3311 12.4746L20.0889 13.6875C20.0127 13.7637 19.8896 13.7637 19.8135 13.6875L19.3154 13.2012C17.2061 11.1445 13.7959 11.1445 11.6865 13.2012L11.1533 13.7227C11.0771 13.7988 10.9541 13.7988 10.8779 13.7227L9.63574 12.5098C9.4834 12.3633 9.4834 12.123 9.63574 11.9766L10.0342 11.584ZM23.54 14.0918L24.6475 15.1699C24.7998 15.3164 24.7998 15.5566 24.6475 15.7031L19.6611 20.5723C19.5088 20.7188 19.2627 20.7188 19.1162 20.5723L15.5771 17.1152C15.542 17.0801 15.4775 17.0801 15.4424 17.1152L11.9033 20.5723C11.751 20.7188 11.5049 20.7188 11.3584 20.5723L6.35449 15.7031C6.20215 15.5566 6.20215 15.3164 6.35449 15.1699L7.46191 14.0918C7.61426 13.9453 7.86035 13.9453 8.00684 14.0918L11.5459 17.5488C11.5811 17.584 11.6455 17.584 11.6807 17.5488L15.2197 14.0918C15.3721 13.9453 15.6182 13.9453 15.7646 14.0918L19.3037 17.5488C19.3389 17.584 19.4033 17.584 19.4385 17.5488L22.9775 14.0918C23.1416 13.9453 23.3877 13.9453 23.54 14.0918Z"
                                fill="white" />
                            <defs>
                                <radialGradient id="paint0_radial_392_10177" cx="0" cy="0" r="1"
                                    gradientUnits="userSpaceOnUse"
                                    gradientTransform="translate(0.500093 15.0005) scale(30)">
                                    <stop stop-color="#5D9DF6" />
                                    <stop offset="1" stop-color="#006FFF" />
                                </radialGradient>
                            </defs>
                        </svg>
                        {{ 'connect_wallet.wallet_list.wallet_connect' | translate }}
                    </button>
                    <button class="button-secondary connectWallet__list_item disabled" (click)="onConnectSequence()">
                        <img src="/assets/image/connectWallet/sequence-wallet.png" alt="Sequence Wallet Icon" />
                        {{ 'connect_wallet.wallet_list.sequence' | translate }}
                    </button>
                </div>

                <div class="connectWallet__footer">
                    <p class="connectWallet__footer_text">
                        {{ 'connect_wallet.footer.text' | translate }}
                    </p>
                    <a>
                        <div class="connectWallet__footer_remark">
                            <svg width="17" height="17" viewBox="0 0 17 17" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M8.41406 15.8692C12.2801 15.8692 15.4141 12.7352 15.4141 8.86914C15.4141 5.00315 12.2801 1.86914 8.41406 1.86914C4.54807 1.86914 1.41406 5.00315 1.41406 8.86914C1.41406 12.7352 4.54807 15.8692 8.41406 15.8692Z"
                                    fill="#F6A425" />
                                <path d="M7.74805 8.20264H9.08139V11.8693H7.74805V8.20264Z" fill="#131313" />
                                <path
                                    d="M8.41341 7.20231C8.87365 7.20231 9.24674 6.82921 9.24674 6.36897C9.24674 5.90874 8.87365 5.53564 8.41341 5.53564C7.95317 5.53564 7.58008 5.90874 7.58008 6.36897C7.58008 6.82921 7.95317 7.20231 8.41341 7.20231Z"
                                    fill="#131313" />
                            </svg>
                            {{ 'connect_wallet.footer.terms' | translate }}
                        </div>
                    </a>
                </div>
            </div>
        </div>
    </main>
</div>